

























































import {
  apiOrderOrderDetail,
  apiOrderOrderQueryLogistics,
  apiSaleAfterStandardEcommerceSaleAfterImmediatelyQuery,
} from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { noop } from 'vtils'
import { redirectTo } from '@/router'
import { Track } from '@/utils'

interface StandardExpressData {
  code?: string
  company?: string
  traces?: Array<{
    icon: string
    title: string
    desc: string
    time: string
  }>
  self?: {
    name: string
    phoneNumber: string
    address: string
  }
}

function getTraceIcon(title: string): string {
  return [
    '已签收',
    '拒收（退件）',
    '超时未签收',
    '已取出快递柜或驿站',
    '快递柜或驿站超时未取',
  ].includes(title)
    ? require('./images/已签收.png')
    : ['已放入快递柜或驿站', '派件中'].includes(title)
    ? require('./images/派送中.png')
    : ['到达派件城市', '超时未更新', '在途中'].includes(title)
    ? require('./images/运输中.png')
    : require('./images/已揽件.png')
}

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '物流详情',
        }))
      }

      query = useQuery<{
        // 通过订单查询
        orderNo?: string
        // 订单可能有拆包，通过拆包查询
        packageId?: string

        // 通过售后查询
        afterSalesId?: string
      }>()

      pageData = useApi<StandardExpressData>(async () => {
        if (this.query.orderNo) {
          const orderData = await apiOrderOrderDetail({
            orderNo: this.query.orderNo,
          })
          if (orderData.selfAddress) {
            return {
              self: {
                name: orderData.selfAddress.name!,
                phoneNumber: orderData.selfAddress.phoneNo!,
                address: `${orderData.selfAddress.province}${orderData.selfAddress.city}${orderData.selfAddress.area}${orderData.selfAddress.detail}`,
              },
            }
          }
          if (
            orderData.consigneeInfo?.packageType === 2 &&
            !this.query.packageId
          ) {
            redirectTo('ExpressPackages', {
              orderNo: this.query.orderNo,
            })
            return new Promise<StandardExpressData>(noop)
          }
          const orderExpressData = await apiOrderOrderQueryLogistics({
            orderNo: this.query.orderNo,
            packageId: this.query.packageId,
          })
          return {
            code: orderExpressData.waybillNo!,
            company: orderExpressData.companyName!,
            traces: (orderExpressData.traces || []).map(item => ({
              icon: getTraceIcon(item.action!),
              title: item.action!,
              desc: item.actionInfo!,
              time: item.actionTime!,
            })),
          }
        }
        const afterSalesExpressData =
          await apiSaleAfterStandardEcommerceSaleAfterImmediatelyQuery({
            id: this.query.afterSalesId!,
          })
        return {
          code: afterSalesExpressData.logisticCode!,
          company: afterSalesExpressData.shipperName!,
          traces: (afterSalesExpressData.traces || []).map(item => ({
            icon: getTraceIcon(item.action),
            title: item.action,
            desc: item.acceptStation,
            time: item.acceptTime,
          })),
        }
      })

      expressData = computed(() => this.pageData.data)

      // 点击线下自提-拨打电话
      handleSelfContactClick = () => {
        dcb.makePhoneCall({
          name: this.expressData.value.self!.name,
          phoneNumber: this.expressData.value.self!.phoneNumber,
        })
      }
    },
)
